// extracted by mini-css-extract-plugin
module.exports = {"formWrap":"src-components-TaxBureauStep-__index__formWrap--24449","captchaBox":"src-components-TaxBureauStep-__index__captchaBox--1H3As"};